var _circle, _path, _path2, _circle2, _circle3, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 173,
    viewBox: "0 0 297 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.037,
    cy: 88.8221,
    r: 84.1778,
    fill: "#F0F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.938 117.849C107.653 125.28 113.613 122.106 115.549 119.01L174.183 69.0839C173.718 64.904 168.571 63.085 166.055 62.698H136.448C132.268 62.698 131.61 60.7629 131.804 59.7953C131.339 56.5443 128.901 55.7315 127.74 55.7315H105.099C99.5258 55.7315 98.5195 60.3758 98.7131 62.698L103.938 117.849Z",
    fill: "#FF5811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.839 126.557C190.416 126.557 192.158 127.718 192.738 112.624L195.641 76.0503C196.105 70.4772 190.416 68.6969 187.513 68.5034H127.718C121.216 68.5034 118.429 74.6958 117.849 77.7919L114.366 118.43C110.65 124.467 106.238 120.945 104.497 118.43C104.961 124.467 111.27 126.364 114.366 126.557H171.839Z",
    fill: "#F09537"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.345,
    cy: 98.9391,
    r: 3.75721,
    fill: "#FF5811"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.141,
    cy: 98.9391,
    r: 3.75721,
    fill: "#FF5811"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.738,
    y: 108.332,
    width: 8.14062,
    height: 3.13101,
    rx: 1.5655,
    fill: "#FF5811"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.796,
    y: 89.0669,
    width: 9.73897,
    height: 2.94315,
    rx: 1.47157,
    transform: "rotate(-18.8554 138.796 89.0669)",
    fill: "#FF5811"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.145,
    y: 86.0734,
    width: 9.73897,
    height: 2.94315,
    rx: 1.47157,
    transform: "rotate(15 166.145 86.0734)",
    fill: "#FF5811"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.269 43.9937H224.087C214.799 43.0648 212.477 34.3181 212.477 30.0609C212.477 17.9857 222.539 15.3539 227.571 15.5474C227.106 5.32998 233.956 1.22752 237.44 0.453463C246.728 -1.86869 251.76 5.29126 253.114 9.1615C262.867 3.58834 268.402 9.93555 269.95 13.8058C280.167 10.5548 283.496 17.0955 283.883 20.7722C294.564 21.7011 296.848 29.2868 296.654 32.9635C296.654 39.93 292.397 43.2197 290.269 43.9937Z",
    fill: "#EDF4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.047 51.6678H200.866C191.577 50.7389 189.255 41.9922 189.255 37.7349C189.255 25.6597 199.318 23.028 204.349 23.2215C203.885 13.004 210.735 8.90156 214.218 8.1275C223.507 5.80536 228.538 12.9653 229.893 16.8355C239.646 11.2624 245.18 17.6096 246.728 21.4798C256.946 18.2288 260.274 24.7695 260.661 28.4463C271.343 29.3751 273.626 36.9608 273.433 40.6376C273.433 47.604 269.176 50.8937 267.047 51.6678Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7919 46.3159H11.6107C2.32215 45.387 0 36.6403 0 32.383C0 20.3078 10.0626 17.6761 15.094 17.8696C14.6295 7.65213 21.4799 3.54966 24.9631 2.77561C34.2517 0.453462 39.283 7.61341 40.6376 11.4836C50.3906 5.91049 55.9251 12.2577 57.4732 16.1279C67.6906 12.8769 71.019 19.4177 71.406 23.0944C82.0879 24.0232 84.3714 31.6089 84.1778 35.2857C84.1778 42.2521 79.9206 45.5418 77.7919 46.3159Z",
    fill: "#EDF4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3691 51.6678H30.1879C20.8993 50.7389 18.5771 41.9922 18.5771 37.7349C18.5771 25.6597 28.6398 23.028 33.6711 23.2215C33.2067 13.004 40.057 8.90156 43.5402 8.1275C52.8288 5.80536 57.8601 12.9653 59.2147 16.8355C68.9678 11.2624 74.5022 17.6096 76.0503 21.4798C86.2678 18.2288 89.5962 24.7695 89.9832 28.4463C100.665 29.3751 102.949 36.9608 102.755 40.6376C102.755 47.604 98.4977 50.8937 96.3691 51.6678Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8896 113.205C74.8896 99.2718 61.3437 94.6275 54.5708 94.047C38.3152 96.3691 38.8963 108.754 44.7016 120.752C112.625 190.997 207.058 151.907 228.151 137.587C234.537 130.621 232.215 122.3 227.571 120.171C193.203 105.774 175.322 123.074 170.678 133.523C156.281 128.879 143.393 134.685 138.749 138.168C132.247 130.737 117.075 131.201 110.302 132.362C101.478 111.463 83.0171 110.883 74.8896 113.205Z",
    fill: "url(#paint0_linear_114_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_12",
    x1: 136.525,
    y1: 94.047,
    x2: 136.525,
    y2: 161.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.4748f7908d88151359fd9ae38748587b.svg";
export { ForwardRef as ReactComponent };